import React from 'react';
import { Link } from 'react-router-dom';
import CellIcon from '../table/CellIcon';

const CardHeaderContent = ({
  children,
  disabled,
  entity,
  href,
  icon,
  iconColour,
  link,
  loading,
  message,
  onClick,
  text,
  title,
}) => {
  const myHref = disabled || loading ? undefined : href;
  const myLink = disabled || loading ? undefined : link;
  const handleClick = onClick ? (e) => { e.preventDefault(); onClick(e); } : undefined;

  return (
    <>
      <div className="aridhia-card-header-content w-100">
        <span title={text}>
          {(icon || entity) && (
          <CellIcon
            colour={iconColour}
            entity={entity}
            loading={loading}
            message={message}
            name={icon}
            title={title}
          />
          )}
          {myHref && (
          <a href={myHref} onClick={handleClick} rel="noopener noreferrer" target="_blank">
            {text}
          </a>
          )}
          {myLink && (<Link to={myLink} title={text}>{text}</Link>)}
          {!myLink && !myHref && (<>{text}</>)}
        </span>
      </div>
      {!loading && (<>{ children }</>)}
    </>
  );
};

export default CardHeaderContent;
